import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Radio.css";
/**
 * @desc Radio
 * @param props
 * @return null
 */
const Radio = props => {
  const { className, ...other } = props;
  return (
    <React.Fragment>
      <label className="ui-radio__label">{props.label}</label>
      <div className={"ui-radio " + className}>
        <input type="radio" {...other} />
        <div className="check" />
      </div>
    </React.Fragment>
  );
};

Radio.propTypes = {
  /** ClassName will be injected into the component's container. You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The label of the checkbox */
  label: PropTypes.string
};

Radio.defaultProps = {
  className: "",
  label: ""
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/UI/Radio/Radio.js